import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Under Construction", -1)
const _hoisted_2 = { class: "message" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.isBetaUser)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["g-under-construction", $setup.classes])
      }, [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, _toDisplayString($props.message || $setup.defaultMessage), 1)
      ], 2))
    : _createCommentVNode("", true)
}